// @ts-nocheck
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
// @ts-ignore
import { NEW_LESSON_ID } from '@yandex-int/k-common/constants';
import { Me, Team, Theme } from '@yandex-int/k-common/typings';
import get from 'lodash/get';
import { Spin } from 'platform-components';
import { Route, Switch } from 'platform-components/src/components/router/router';
import { getMe } from 'platform-components/src/components/user/selectors';
import { InjectedProps as WithRouterProps, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { bindActionCreators, Dispatch } from 'redux';

import {
    SEARCH_PARAM_LESSON_SOURCE,
    SEARCH_PARAM_RELOAD_LESSON_ID,
    SEARCH_PARAM_RELOAD_SYMBOL,
} from 'common.components/constants';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import * as userActions from 'common.components/user/actions';
import { getCurrentClass } from 'common.components/user/selectors';
import { CourseSubject } from 'store/courses/typings';
import * as themesActions from 'store/themes/actions';
import * as themesSelectors from 'store/themes/selectors';
import { getCurrentYearCourseUtil, getSearchStringCourseIdOrDefault } from 'utils/get-course';

import { Library__informatics } from '../__informatics/library__informatics';
import Pages from '../__pages/library__pages';
import { ReduxTeacherStore, RootAction } from '../../../typings';
import { actions as lessonWidgetActions } from '../../lesson-editor-widget/actions';
import { CalendarPlanTheme } from '../../library.calendar-plan-theme/calendar-plan-theme';
import Sidebar from '../../library.sidebar/sidebar';
import * as actions from '../../library.store/actions';
import { getSubjectLists } from '../../library.store/selectors';
import TabContent from '../../library.tab-content/tab-content';

import './library__content.scss';

interface StoreProps {
    doesThemeExist: boolean;
    currentTeam: Team | null;
    me: Me | null;
    lessonId: number | null;
    courseId: number | null;
    themesLoadingStatus: LOADING_STATUSES;
    subjects: Array<CourseSubject>;
}

interface DispatchProps {
    getFullClesson: typeof lessonActions.getFullClessonRequest;
    getLessonRequest: typeof lessonActions.getLessonRequest;
    selectDeepLinkStack: typeof actions.selectDeepLinkStack;
    setWizardVariables: typeof userActions.setWizardVariables;
    toggleLessonModal: typeof lessonViewActions.toggleModal;
    loadLessonViewData: typeof lessonViewActions.loadLessonViewData;
    toggleLessonWidget: typeof lessonWidgetActions.toggleLessonWidget;
    getRootThemesRequest: typeof themesActions.getRootThemesRequest;
    saveLesson: typeof actions.saveLesson;
    addNewSubject: typeof actions.addNewSubject;
    getRootThemesSuccess: typeof themesActions.getRootThemesSuccess;
    setLessonSource: typeof lessonActions.setLessonSource;
}

interface HOCProps extends WithRouterProps {
    intl: IntlShape;
}

export interface Props extends HOCProps, StoreProps, DispatchProps {
    showBackToCalendarPlan?: boolean;
}

interface Context {
    data: {
        getThemesFlat: Array<Theme>;
    };
    initialRender: boolean;
    staticUrls: {
        externalCreateLesson: string;
    };
}

export class LibraryContent extends React.Component<Props> {
    static contextTypes = {
        data: PropTypes.object,
        initialRender: PropTypes.bool.isRequired,
        staticUrls: PropTypes.object.isRequired,
    };

    constructor(props: Props, context: Context) {
        super(props, context);

        const {
            getRootThemesSuccess,
            match: {
                params: { subject },
            },
        } = props;
        const { data, initialRender } = context;

        if (initialRender && data.getThemesFlat) {
            getRootThemesSuccess(subject, data.getThemesFlat);
        } else {
            this.loadThemes();
        }
    }

    componentDidMount() {
        this.handleSearchParameters();
    }

    // eslint-disable-next-line complexity
    componentDidUpdate(prevProps: Props) {
        const {
            doesThemeExist,
            location,
            match: {
                params: { subject },
            },
        } = this.props;
        const {
            doesThemeExist: prevDoesThemeExist,
            location: prevLocation,
            match: {
                params: { subject: prevSubject },
            },
        } = prevProps;

        if (subject && subject !== prevSubject) {
            this.loadThemes();
        }

        const themeExist = !prevDoesThemeExist && doesThemeExist;
        if (location !== prevLocation || themeExist) {
            this.handleSearchParameters();
        }
    }

    // eslint-disable-next-line complexity
    handleSearchParameters = () => {
        const {
            doesThemeExist,
            courseId: propsCourseId,
            getFullClesson,
            loadLessonViewData,
            history,
            location: { pathname, search },
            match: {
                params: { themeId, classId, subject, lessonId: lessonIdFromParams },
            },
            me,
            selectDeepLinkStack,
            setWizardVariables,
            toggleLessonModal,
            toggleLessonWidget,
            subjects,
            addNewSubject,
            setLessonSource,
        } = this.props;
        const {
            initialRender,
            data: { getCourses },
        } = this.context;
        const {
            openLesson,
            lessonId,
            preparedLessonId,
            problemId: stackId,
            redirectOrAddSubject,
            retpath,
            [SEARCH_PARAM_LESSON_SOURCE]: lessonSource,
            [SEARCH_PARAM_RELOAD_LESSON_ID]: lessonToReload,
            ...restParams
        } = qs.parse(search);

        const courseId = initialRender ? get(getCurrentYearCourseUtil(getCourses || []), 'id') : propsCourseId;

        const restParamsString = qs.stringify(restParams, { arrayFormat: 'bracket' });
        const pathWithRestParams = `${pathname}?${restParamsString}`;

        if (openLesson) {
            loadLessonViewData({ lessonId: Number(lessonIdFromParams), courseId: propsCourseId });
            toggleLessonModal(true);
            history.replace(pathWithRestParams);
        } else if (lessonId && courseId) {
            if (lessonId === NEW_LESSON_ID) {
                toggleLessonWidget(true);
            } else {
                const searchStringCourseIdOrDefault = getSearchStringCourseIdOrDefault(me!, courseId)!;

                getFullClesson({
                    courseId: searchStringCourseIdOrDefault,
                    clessonId: lessonId,
                });
                toggleLessonModal(true);
            }

            history.replace(pathWithRestParams);
        } else if (stackId && themeId && doesThemeExist) {
            selectDeepLinkStack(Number(stackId));
            setWizardVariables({ deepLinkStack: true });

            history.replace({ search: restParamsString });
        } else if (preparedLessonId && ((themeId && doesThemeExist) || lessonSource)) {
            loadLessonViewData({
                lessonId: Number(preparedLessonId),
                courseId: propsCourseId,
            });
            toggleLessonModal(true);
            setWizardVariables({ deepLinkPreparedLesson: true });
            setLessonSource({ source: lessonSource });

            history.replace({ search: restParamsString });

            ym('reachGoal', 'teacher_lesson_creation_readylesson_visit', {
                teacher_id: me?.id,
                team_id: Number(classId),
                subject,
                lesson_id: Number(preparedLessonId),
                theme_id: themeId ? Number(themeId) : undefined,
                lesson_source: lessonSource,
            });
        } else if (redirectOrAddSubject && retpath) {
            if (subjects.find((s) => s.subject === redirectOrAddSubject)) {
                history.replace(retpath);
            } else {
                addNewSubject({
                    teamId: Number(classId),
                    subject: redirectOrAddSubject,
                    onSuccess: () => history.push(retpath),
                });
                history.replace(pathWithRestParams);
            }
        } else if (lessonToReload) {
            const [clessonIdToReload, courseIdToReload] =
                decodeURIComponent(lessonToReload).split(SEARCH_PARAM_RELOAD_SYMBOL);
            if (clessonIdToReload && courseIdToReload) {
                getFullClesson({ courseId: Number(courseIdToReload), clessonId: Number(clessonIdToReload) });
                toggleLessonWidget(true);
            }
        }
    };

    loadThemes = () => {
        const {
            match: {
                params: { subject },
            },
            getRootThemesRequest,
            themesLoadingStatus,
        } = this.props;

        if (themesLoadingStatus === LOADING_STATUSES.UNSENT) {
            getRootThemesRequest(subject);
        }
    };

    renderLibraryContent = () => {
        const { themesLoadingStatus, showBackToCalendarPlan } = this.props;

        const isLoadingThemes = themesLoadingStatus === LOADING_STATUSES.LOADING;

        return (
            <div className="library__content">
                {isLoadingThemes ? (
                    <Spin center />
                ) : (
                    <>
                        <Sidebar showBackToCalendarPlan={showBackToCalendarPlan} />
                        <div className="library__pages">
                            <Pages />
                        </div>
                    </>
                )}
            </div>
        );
    };

    render() {
        const { staticUrls } = this.context;
        const {
            match: {
                params: { subject },
            },
        } = this.props;

        if (subject === 'informatics') {
            return <Library__informatics />;
        }

        return (
            <>
                <Switch>
                    <Route
                        component={CalendarPlanTheme}
                        exact
                        path={staticUrls.labClassLibrarySubjectCalendarPlanTheme}
                    />
                    <Route component={CalendarPlanTheme} exact path={staticUrls.labLibrarySubjectCalendarPlanTheme} />
                    <Route component={TabContent} path={staticUrls.labClassLibraryCalendarPlanShowcaseLesson} />
                    <Route component={TabContent} path={staticUrls.labLibraryCalendarPlanShowcaseLesson} />
                    <Route component={TabContent} path={staticUrls.labClassLibrarySubjectTab} />
                    <Route component={TabContent} path={staticUrls.labLibrarySubjectTab} />
                    <Route component={TabContent} path={staticUrls.labLibrarySubjectCalendarPlan} />
                    <Route component={TabContent} path={staticUrls.labClassLibrarySubjectCalendarPlan} />
                    <Route render={this.renderLibraryContent} />
                </Switch>
            </>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps): StoreProps => {
    const {
        location: { search },
        match: {
            params: { classId: classIdFromUrl, subject, themeId },
        },
    } = ownProps;
    const query = qs.parse(search);
    const classId = Number(classIdFromUrl);
    const currentTeam = getCurrentClass(storeState, { classId });
    const grade = currentTeam?.level || Number(query.grade);

    return {
        doesThemeExist: themesSelectors.getDoesThemeExist(storeState, {
            subject,
            grade,
            themeId: Number(themeId),
        }),
        me: getMe(storeState),
        courseId: getCurrentYearCourseId(storeState),
        themesLoadingStatus: themesSelectors.getRootThemesLoadingStatus(storeState, { subject }),
        lessonId: lessonSelectors.getLessonId(storeState),
        currentTeam: getCurrentClass(storeState, { classId }),
        // @ts-ignore
        subjects: getSubjectLists(storeState, { classId, grade }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            getRootThemesRequest: themesActions.getRootThemesRequest,
            getRootThemesSuccess: themesActions.getRootThemesSuccess,
            selectDeepLinkStack: actions.selectDeepLinkStack,
            getFullClesson: lessonActions.getFullClessonRequest,
            getLessonRequest: lessonActions.getLessonRequest,
            toggleLessonModal: lessonViewActions.toggleModal,
            loadLessonViewData: lessonViewActions.loadLessonViewData,
            toggleLessonWidget: lessonWidgetActions.toggleLessonWidget,
            setWizardVariables: userActions.setWizardVariables,
            saveLesson: actions.saveLesson,
            addNewSubject: actions.addNewSubject,
            setLessonSource: lessonActions.setLessonSource,
        },
        dispatch
    );
};

export default withRouterPath(injectIntl(connect(mapStateToProps, mapDispatchToProps)(LibraryContent)));
